import { cn } from '@/lib/utils'

/**
 * Signin Wordmark — in-app paper/ink/action register variant of the landing
 * Wordmark. Renders the brand mast at signin without wrapping in a Link
 * (the dashboard target is unreachable until auth completes).
 *
 * Spec: docs/superpowers/specs/2026-05-13-signin-mini-spec.md §1.1 row 1.
 *
 * Differences from landing's hero/wordmark.tsx:
 * - No Seal sub-component (inline 道 square instead — mirrors shell §1.2
 *   BrandMark structure)
 * - Uses in-app `text-action` (chroma 0.16) instead of landing's
 *   `text-vermilion` (chroma 0.18) — paper-cream + vermilion is the brand
 *   register; the chromatic step-down at signin matches shell BrandMark
 * - No <Link> wrapper — signin is pre-auth, brand mark is static identity
 */
export function Wordmark({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                'flex items-center gap-3 font-serif text-[24px] leading-none tracking-[-0.015em] text-ink',
                className
            )}
        >
            <span
                aria-hidden
                // reason: brand identity at signin threshold — single composite
                // mark naming the publication (spine §7.4 figure-coded
                // vermilion). Counts as 1 of 2 at-rest placements per spec §6.
                className="inline-flex size-9 items-center justify-center rounded-[3px] border-[1.5px] border-action font-mincho text-[20px] leading-none text-action"
            >
                道
            </span>
            <span>
                Kanji
                {/* reason: italic vermilion 'do' completes the composite brand
                    mark started by the 道 seal — same placement accounting */}
                <span className="font-serif text-action italic">do</span>
            </span>
        </div>
    )
}
